<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <label class="label-input">Content</label>
          <div style="margin-bottom: 20px">
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                name="sectionBackground"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields['sectionBackground']"
                @change="handleChangeSectionBackground"
              />
              <v-text-field v-model="fields['sectionBackground']" label="Background Color" />
            </div>
          </div>
        </div>
        <div>
          <div class="d-flex justify-space-between align-center">
            <div>
              <label style="margin-bottom: 0" class="label-input">Items</label>
            </div>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, i) in fields['listItem']" :key="i">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>Item {{ i + 1 }}</span>
                  <v-btn icon @click.stop="handleRemoveItem(i)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="">
                  <div class="mb-6">
                    <UploadImage
                      @callback="obj => handleUploadImage(obj, i)"
                      :image="{ imageSrc: item.image }"
                      :height="`250`"
                      :typeUpload="'image'"
                      @callbackDelete="handleRemoveUpload(i)"
                    />
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { replaceImageUrl } from '../common/utils';
export default {
  name: 'marquee-image',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        sectionBackground: '',
        listItem: [
          // {
          //   image: "",
          //   htmlText: "",
          // }
        ],
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionMarqueeImage(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleChangeSectionBackground(event) {
      this.fields['sectionBackground'] = event.target.value;
    },

    handleUploadImage(obj, index) {
      this.fields['listItem'][index].image = obj.imageSrc;
    },
    handleRemoveUpload(index) {
      this.fields['listItem'][index].image = '';
    },
    handleAddItem() {
      this.fields['listItem'].push({
        image: replaceImageUrl(
          'https://cdn.skyfastimg.com/images/2025/10/29/image-690193829957da739b83f089.webp?w=50&amp;h=50&amp;q=80',
        ),
      });
    },
    handleRemoveItem(index) {
      this.fields['listItem'].splice(index, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.ck-editor__editable_inline {
  min-height: 300px;
}
.ck-editor__editable {
  min-height: 300px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
